import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from 'src/app/shared/services/user.service';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
  selector: 'not-found404',
  templateUrl: './not-found404.component.html',
  styleUrls: ['./not-found404.component.scss'],
  imports: [RouterLink, MatButtonModule, PageHeaderComponent, EmptyStateComponent],
})
export class PageNotFoundComponent {
  private readonly usrSvc = inject(UserService);

  logout() {
    this.usrSvc.logout();
  }
}
